<template>
  <!-- <v-snackbar
    v-model="notif.visible"
    :color="notif.status ? 'green' : 'red'"
    variant="flat"
    location="top right"
    rounded="pill"
    :timeout="notif.autoHide"
  >
    {{ notif.message }}
    <template v-slot:actions>
      <v-btn class="text-none" variant="text" @click="notif.visible = false">
        Close
      </v-btn>
    </template>
  </v-snackbar> -->
  <Notification 
    v-model="notif.visible"
    :status="notif.status"
    :message="notif.message"
    @close-modal="closeModal"
  />
  <v-app>
    <RouterView />
  </v-app>
</template>

<script setup>
import { notifStore } from "@/store/notif";
import Notification from "./components/Dialog/Notification.vue";

const notif = notifStore.state;

const closeModal = () => {
  notif.visible = false;
};
</script>
<style>
@import "./styles/main.css";
</style>
